import React from "react";
import {
  Container,
  Box,
  Typography,
  Divider,
  List,
  ListItem
} from "@mui/material";
import { useTranslation } from "react-i18next";

const PrivacyPolicyPage = () => {
  const { t } = useTranslation();

  const title = t("privacy_policy.title");
  const sections = t("privacy_policy.sections", { returnObjects: true }) || [];

  const renderOrderedList = (orderedList) => {
    if (!orderedList || !Array.isArray(orderedList.items)) return null;
    const listStyleType = orderedList.type === "alpha" ? "lower-alpha" : "decimal";
    return (
      <ol style={{ paddingLeft: "1.25rem", listStyleType }}>
        {orderedList.items.map((item, idx) => (
          <li key={idx} style={{ marginBottom: 6 }}>
            <Typography variant="body2" component="span">
              {item}
            </Typography>
          </li>
        ))}
      </ol>
    );
  };

  return (
    <Container
      maxWidth="md"
      sx={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        px: 2
      }}
    >
      <Box
        className="white-background"
        sx={{
          width: "100%",
          maxWidth: 900,
          p: { xs: 2, sm: 4 },
          borderRadius: 2,
          textAlign: "left",
          overflowY: "auto"
        }}
      >
        <Typography variant="h3" color="primary" gutterBottom>
          {title}
        </Typography>

        <Divider sx={{ my: 3 }} />

        {sections.map((sec, idx) => (
          <Box key={idx} sx={{ mb: 3 }}>
            {sec.heading && (
              <Typography variant="h5" color="primary" gutterBottom>
                {sec.heading}
              </Typography>
            )}

            {sec.text && (
              <Typography
                variant="body1"
                paragraph
                sx={{ whiteSpace: "pre-line" }}
              >
                {sec.text}
              </Typography>
            )}

            {Array.isArray(sec.list) && sec.list.length > 0 && (
              <List dense sx={{ pl: 0 }}>
                {sec.list.map((item, i) => (
                  <ListItem key={i} sx={{ pl: 0 }}>
                    <Typography variant="body2">{item}</Typography>
                  </ListItem>
                ))}
              </List>
            )}

            {sec.orderedList && renderOrderedList(sec.orderedList)}

            {Array.isArray(sec.subsections) &&
              sec.subsections.map((sub, k) => (
                <Box key={k} sx={{ mb: 2, ml: 1 }}>
                  {sub.heading && (
                    <Typography variant="subtitle1" gutterBottom>
                      {sub.heading}
                    </Typography>
                  )}
                  {sub.text && (
                    <Typography
                      variant="body2"
                      paragraph
                      sx={{ whiteSpace: "pre-line" }}
                    >
                      {sub.text}
                    </Typography>
                  )}
                </Box>
              ))}

            {Array.isArray(sec.links) && sec.links.length > 0 && (
              <Box sx={{ mt: 1 }}>
                {sec.links.map((lnk, lIdx) => (
                  <Typography key={lIdx} variant="body2">
                    <a
                      href={lnk.href}
                      target="_blank"
                      rel="noreferrer"
                      style={{ textDecoration: "underline" }}
                    >
                      {lnk.label}
                    </a>
                  </Typography>
                ))}
              </Box>
            )}

            {sec.note && (
              <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 1 }}>
                {sec.note}
              </Typography>
            )}
          </Box>
        ))}
      </Box>
    </Container>
  );
};

export default PrivacyPolicyPage;
